module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/DIGITAL_STYLE.2d1222a7.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/DIGITAL_STYLE.png
// module id = 1148
// module chunks = 16